import { BaseFetch } from "../main-model"
export default class TitleModel extends BaseFetch {
  getTitleBy = (data) =>
    this.authFetch({
      url: "title/getTitleBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getTitleById = (data) =>
    this.authFetch({
      url: "title/getTitleById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateTitleById = (data) =>
    this.authFetch({
      url: "title/updateTitleById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertTitle = (data) =>
    this.authFetch({
      url: "title/insertTitle",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteTitleById = (data) =>
    this.authFetch({
      url: "title/deleteTitleById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
